import { LoadingOverlay } from '@tcc-online/common-components';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslate } from 'react-translate.ts';

import UserActions from '../../actions/UserActions';
import BasePageLayout from '../../common/components/BasePageLayout/BasePageLayout';
import { ChangePasswordForm } from '../../common/components/forms/ChangePasswordForm';
import BaseCard from '../../components/cards/BaseCard/BaseCard';
import UserSelectors from '../../selectors/UserSelectors';
import { UserService } from '../../services/common/UserService';
import { AppDispatch } from '../../reducers/store';
import UserSlice from '../../common/slices/UserSlice';
import { useNavigate } from 'react-router-dom';
import { SIGN_IN_PATH } from '../../constants/route.constants';
import styles from './PasswordPage.module.scss';
import { css, cx } from '@emotion/css';
import { useTheme } from '@tcc-online/react-theme-provider';
import ExclamationCircleFillIcon from 'react-bootstrap-icons/dist/icons/exclamation-circle-fill';

export default function PasswordPage() {
    const translate = useTranslate();
    const dispatch = useDispatch<AppDispatch>();
    const { loading, uploading, success, error } =
        UserSelectors.useGetPasswordState();
    const userInfo = useSelector(UserSlice.state.info);
    const navigate = useNavigate();
    const [theme] = useTheme();

    return (
        <BasePageLayout heading={translate('fe.change-password.title')}>
            {userInfo.data?.forceChangePassword === true && (
                <BaseCard
                    className={cx(
                        styles.warning,
                        css({
                            background: theme.warningColor,
                            color: theme.textLightColor,
                        }),
                    )}
                >
                    <ExclamationCircleFillIcon />
                    {translate('fe.warning.password-change-required')}
                </BaseCard>
            )}
            <BaseCard>
                {(loading || uploading) && <LoadingOverlay isLoading />}
                <ChangePasswordForm
                    onSubmit={resetPassword}
                    reinit={success}
                    error={error}
                    requireOldPassword={userInfo.data?.hasPassword === true}
                />
            </BaseCard>
        </BasePageLayout>
    );

    async function resetPassword(controlPassword: string, password: string) {
        const result = await dispatch(
            UserActions.changePassword({
                controlPassword,
                password,
                userId: UserService.getUserId(),
            }),
        ).unwrap();

        if (result?.status === 204) {
            navigate(SIGN_IN_PATH, {
                replace: true,
                relative: 'path',
            });
        }
    }
}
